/* eslint-disable @angular-eslint/component-selector */

import { Component, Input, OnInit } from '@angular/core';
import { Audit } from 'app/core/models/audit.model';
import { obj2Html } from '../../../core/lib/js-utils';
import { camelCaseToFlat } from 'app/core/lib/string-utils';
import { DatePipe } from '@angular/common';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: '[app-audit-note-create-row]',
    templateUrl: './audit-note-create-row.component.html',
    styleUrls: ['./audit-note-create-row.component.scss'],
    imports: [DatePipe, BlankValueDashPipe]
})
export class AuditNoteCreateRowComponent implements OnInit {
  @Input() audit: Audit;
  newValueHtml;
  modelType;
  modelId;
  modelHumanizedName;

  constructor() {}

  ngOnInit() {
    const {
      userId, // eslint-disable-line unused-imports/no-unused-vars
      data, // eslint-disable-line unused-imports/no-unused-vars
      modelType,
      modelId,
      ...changes
    } = this.audit.auditedChanges;

    this.modelType = modelType;
    this.modelId = modelId;
    this.modelHumanizedName = camelCaseToFlat(modelType);

    this.newValueHtml = obj2Html(changes);
  }
}
